// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.NotificationsToast_gridContainer__gaQDU {
    display: grid;
    grid-template-areas:
      'icon main close'
      'icon main closeAndRead';
    width:100%;
    z-index: 10000; /* Make sure it's always diplayed over everything else */
  }

.NotificationsToast_gridItemIcon__Z908e { 
    grid-area: icon; 
    width: 30px;
}

.NotificationsToast_gridItemMain__lmPxD { 
  grid-area: main;
  width: 300px; 
}

.NotificationsToast_gridItemClose__nukH5 { 
  grid-area: close;
  width: 30px;
 }

.NotificationsToast_gridItemCloseAndRead__\\+qQUE { 
    grid-area: closeAndRead;
    width: 30px;
    padding-top: 15px;
    display: flex;
    flex-direction: column;
    justify-content: flex-end
    
}


  .NotificationsToast_actionButton__zOd7k {
    min-height: 50px;
    width: 140px;
    align-items: center;
    margin-top: 10px;
  }`, "",{"version":3,"sources":["webpack://./src/styles/NotificationsToast.module.css"],"names":[],"mappings":"AAAA;IACI,aAAa;IACb;;8BAE0B;IAC1B,UAAU;IACV,cAAc,EAAE,wDAAwD;EAC1E;;AAEF;IACI,eAAe;IACf,WAAW;AACf;;AAEA;EACE,eAAe;EACf,YAAY;AACd;;AAEA;EACE,gBAAgB;EAChB,WAAW;CACZ;;AAED;IACI,uBAAuB;IACvB,WAAW;IACX,iBAAiB;IACjB,aAAa;IACb,sBAAsB;IACtB;;AAEJ;;;EAGE;IACE,gBAAgB;IAChB,YAAY;IACZ,mBAAmB;IACnB,gBAAgB;EAClB","sourcesContent":[".gridContainer {\n    display: grid;\n    grid-template-areas:\n      'icon main close'\n      'icon main closeAndRead';\n    width:100%;\n    z-index: 10000; /* Make sure it's always diplayed over everything else */\n  }\n\n.gridItemIcon { \n    grid-area: icon; \n    width: 30px;\n}\n\n.gridItemMain { \n  grid-area: main;\n  width: 300px; \n}\n\n.gridItemClose { \n  grid-area: close;\n  width: 30px;\n }\n\n.gridItemCloseAndRead { \n    grid-area: closeAndRead;\n    width: 30px;\n    padding-top: 15px;\n    display: flex;\n    flex-direction: column;\n    justify-content: flex-end\n    \n}\n\n\n  .actionButton {\n    min-height: 50px;\n    width: 140px;\n    align-items: center;\n    margin-top: 10px;\n  }"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"gridContainer": `NotificationsToast_gridContainer__gaQDU`,
	"gridItemIcon": `NotificationsToast_gridItemIcon__Z908e`,
	"gridItemMain": `NotificationsToast_gridItemMain__lmPxD`,
	"gridItemClose": `NotificationsToast_gridItemClose__nukH5`,
	"gridItemCloseAndRead": `NotificationsToast_gridItemCloseAndRead__+qQUE`,
	"actionButton": `NotificationsToast_actionButton__zOd7k`
};
export default ___CSS_LOADER_EXPORT___;
